
var modalLess = {};
import genaration from '../../utils/classname';
export var modalClass = genaration(modalLess, 'modal');